import axios from 'axios'; // Import axios to make HTTP requests

// Function to send FAQ request
export const sendFAQRequest = (text, language) => {
    return axios.post(
        'https://us-central1-chatbot-418311.cloudfunctions.net/FAQ_matching/find-category',
        { text, language },
        {
            headers: {
                'Content-Type': 'application/json',
            },
        }
    )
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error('Error making API call:', error);
            return null;
        });
};

